// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1uMGJ","fileBtn":"File_fileBtn__2n-uN","closeBtn":"File_closeBtn__2b3Te","fileSelected":"File_fileSelected__2et-i","disabled":"File_disabled__zqF9E"};